import { ISolCustomerServiceMock } from "@/services";

export const mockSolCustomerService = (): ISolCustomerServiceMock => ({
  getEmployee: jest.fn(),
  getVehicle: jest.fn(),
  getImage: jest.fn(),
  orders: {
    getRequestHistorial: jest.fn(),
    savePickUpService: jest.fn(),
    getFaults: jest.fn(),
    saveAssistanceService: jest.fn(),
    getDenominations: jest.fn(),
    getPacks: jest.fn(),
    saveDeliveryService: jest.fn(),
    getSupply: jest.fn(),
    saveSupplyMaterialService: jest.fn(),
    saveServiceRating: jest.fn(),
    getServiceRating: jest.fn(),
    getPickUpService: jest.fn(),
    getAssistanceService: jest.fn(),
    getDeliveryService: jest.fn(),
    getSupplyMaterialService: jest.fn(),
    getCancellationReasonsService: jest.fn(),
    patchCancelPickupService: jest.fn(),
    patchCancelDeliveryService: jest.fn(),
    patchCancelDeliveryExchangeService: jest.fn(),
    patchCancelSupplyMaterialService: jest.fn(),
    patchCancelAssistanceService: jest.fn(),
    postGenerateOrdersReport: jest.fn(),
    getTypeClientsReport: jest.fn(),
    getSupplyCounters: jest.fn(),
  },
  currency: {
    getCurrency: jest.fn(),
  },
  employees: {
    postGenerateEmployeeSearchReport: jest.fn(),
  },
});
